import { render } from "./bbAreaManageViews.vue?vue&type=template&id=5b25c3e6"
import script from "./bbAreaManageViews.vue?vue&type=script&lang=jsx"
export * from "./bbAreaManageViews.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__